import { getField, updateField } from "vuex-map-fields";

import API from "@/api";

export const state = () => ({
  // table
  datasets: [],
  loadingTable: false,
  // filtros
  selectedSearchFonte: null,
  textSearchDescription: "",
  datasetMap: {},
  searchDataset: [],
  // paginacao
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  currentPage: 1,
});

export const getters = {
  getField,
  formatDataset: (state) => (code) => formatDataset(state, code),
};

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };

  config.params.append("size", state.pagination.size);
  config.params.append("page", state.currentPage - 1);
  config.params.append("sort", "dsFonte");
  config.params.append("sort", "dsDataset");

  if (state.selectedSearchFonte) {
    config.params.append("dsFonte", state.selectedSearchFonte.toString());
  }

  if (state.textSearchDescription) {
    config.params.append("description", state.textSearchDescription.toString());
  }

  return config;
}

function formatDataset(state, enumCode) {
  if (
    Object.keys(state.datasetMap).length === 0 ||
    !state.datasetMap[enumCode]
  ) {
    return enumCode;
  } else {
    return state.datasetMap[enumCode];
  }
}

function objectToMap(status, objectName) {
  let map = {};
  status.forEach((elem) => {
    if (objectName == "fonte") {
      map[elem.dsFonte] = elem.label;
    } else if (objectName == "dataset") {
      map[elem.dsDataset] = elem.label;
    } else {
      map[elem.code] = elem.label;
    }
  });
  return map;
}

export const actions = {
  async get({ dispatch, state, commit, rootState }, payload) {
    commit("updateField", { path: "pagination.offset", value: 0 });
    commit("updateField", { path: "datasets", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });

    const result = await API.axios.get(
      "/bff/api/v1/controle-cargas/datasets",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
    }
    if (result.data.content) {
      commit("updateField", { path: "datasets", value: result.data.content });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getPage({ state, commit, rootState }, payload) {
    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/bff/api/v1/controle-cargas/datasets",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      // update table items
      commit("updateField", { path: "datasets", value: result.data.content });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async createDataset({ dispatch, state }, { datasetForm }) {
    const response = await API.axios.post(
      `/bff/api/v1/controle-cargas/fontes/${datasetForm.dsFonte}/datasets`,
      datasetForm
    );
    return response;
  },

  async getDatasetList({ dispatch, state, commit, rootState }, payload) {
    const result = await API.axios.get(
      `/bff/api/v1/controle-cargas/datasets?unpaged=true&sort=dsDataset`
    );
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", {
        path: "searchDataset",
        value: result.data?.content,
      });
      commit("updateField", {
        path: "datasetMap",
        value: objectToMap(result.data?.content, "dataset"),
      });
    }
    return result;
  },

  async updateDataset({ dispatch, state }, { datasetForm }) {
    const response = await API.axios.put(
      `/bff/api/v1/controle-cargas/fontes/${datasetForm.dsFonte}/datasets/${datasetForm.dsDataset}`,
      datasetForm
    );
    return response;
  },

  async deleteDataset({ dispatch, state }, { dsDataset, dsFonte }) {
    const response = await API.axios.delete(
      `/bff/api/v1/controle-cargas/fontes/${dsFonte}/datasets/${dsDataset}`
    );
    return response;
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, payload) {
    state.pagination.size = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
